import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // timeout: 5000,
   // Set the default timeout for requests to 5 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
